<script>
import { mapGetters } from 'vuex';
import request from '@/utils/request';
import PaginatedList from '@/views/components/PaginatedList';
import SetsHeader from './components/SetsHeader';
import Set from './components/Set';

export default {
  components: {
    SetsHeader,
    Set,
  },
  extends: PaginatedList,
  computed: {
    ...mapGetters({
      items: 'sets/list/getData',
      paginationParams: 'sets/list/getPaginationParams',
      isLoadingSets: 'sets/list/getIsLoading',
      isLoaded: 'sets/list/getIsLoaded',
    }),
  },
  methods: {
    async closeModal(response) {
      try {
        this.isOpen = !this.isOpen;

        if (response) {
          await request.delete(`/sets/${this.selectedItem.uuid}`);

          await this.navigate({
            timestamp: new Date().getTime(),
          });

          this.$notify({
            type: 'success',
            title: 'Επιτυχία',
            text: 'Το Set διαγράφτηκε επιτυχώς!!',
          });
        }
      } catch (err) {
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'To αίτημα απέτυχε',
        });
      }
    },
  },
};
</script>
